import Vue from "vue";
import VueRouter from "vue-router";
import { connect } from "@/utils/socket";
import { reroute } from "@/utils/auth";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/signin",
    name: "Login",
    component: () => import("../views/Start"),
  },
  {
    path: "/signout",
    component: () => import("../views/Signout"),
  },
  {
    path: "/domains",
    name: "DomainsRepos",
    component: () => import("../views/DomainsRepos"),
  },
  {
    path: "/domains/:domainUID",
    name: "ComputersGroups",
    component: () => import("../views/ComputersGroups"),
  },
  {
    path: "/domains/:domainUID/computers/:computerUID/packages",
    name: "ComputerPackages",
    component: () => import("../views/ComputerPackages"),
  },
  {
    path: "/domains/:domainUID/groups/:groupUID/packages",
    name: "GroupPackages",
    component: () => import("../views/GroupPackages"),
  },
  {
    path: "/domains/:domainUID/shares",
    name: "DomainShares",
    component: () => import("../views/DomainShares"),
  },
  {
    path: "/repos/:repoUID",
    name: "Repos",
    component: () => import("../views/Repo"),
  },
  {
    path: "/domains/:domainUID/computers/:computerUID/applications",
    name: "ComputerApplications",
    component: () => import("../views/ComputerApplications"),
  },
  {
    path: "/domains/:domainUID/applications",
    name: "ComputersApplications",
    component: () => import("../views/ComputersApplications.vue"),
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/Profile.vue"),
  },
  {
    path: "/resetpassword/:challange",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("../views/Settings.vue"),
  },
  {
    path: "/unavailable",
    name: "Unavailable",
    component: () => import("../views/Unavailable.vue"),
  },
  {
    path: "/api-documentation",
    name: "API-Documentation",
    component: () => import("../views/ApiDocumentation.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "is-active",
  linkExactActiveClass: "is-active",
  routes,
});

router.afterEach((to) => {
  if (
    !store.state.auth.success &&
    !to.path.includes("/resetpassword") &&
    to.path !== "/signin" &&
    to.path !== "/unavailable"
  ) {
    reroute();
    return;
  }

  connect();
});

export default router;
